import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'SvgMask' })({
    root: {
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 0,
        boxSizing: 'border-box',
        width: '100vw',
        height: '100vh'
    },
    backdrop: {
        width: '100%',
        height: '100%',
        fill: 'white'
    },
    window: {
        fill: 'black'
    },
    outline: {
        stroke: '#ECECEC',
        strokeWidth: 1
    }
});
